// assets/biobio-campanhas.js
// Guarda de vencimento do calendario de campanhas (spec 2026-09-24, emenda E1).
// O Liquid so emite o que vale no instante do render, mas a pagina pode ficar
// aberta ou vir do cache depois do fim. Tres tipos de elemento, todos marcados
// com [data-campanha-fim] (segundos Unix):
// 1. [data-campanha-fim] simples (tarja, faixa): vencido some com display none
//    (o atributo hidden nao vence o display de autor, ja mordeu na faixa do
//    topo), na carga ou com a pagina aberta.
// 2. [data-campanha-recarregar] (slide da home, marcador do compre junto):
//    vencido recarrega uma vez, com parametro que fura o cache (marca no
//    sessionStorage por pagina e fim, entao nunca entra em laco). Na CARGA:
//    uma recarga por sessao (qualquer marca da mesma pagina e fim bloqueia).
//    Com a pagina ABERTA (timer, aba que volta, nodo inserido): mesma janela
//    do essencial, no maximo uma recarga por minuto por pagina e fim. A
//    recarga com a pagina aberta existe porque o slide nao sai do carrossel
//    ja montado: so escondido, o Swiper segue com as posicoes do init e o
//    carrossel fica em branco. Se a recarga nao acontece (marca dentro da
//    janela, ou sessionStorage bloqueado), esconde e segue.
// 3. [data-campanha-essencial] (o <pdp-offer> com a oferta da campanha, unico
//    caminho de compra da PDP-mestre): NUNCA some. Vencido na carga OU com a
//    pagina aberta: recarrega, no maximo uma vez por minuto por pagina e fim (a
//    marca guarda a hora da ultima recarga), e a pagina nova volta com a oferta
//    do proprio produto. Se a recarga nao acontece, fica visivel e o laco
//    segue: oferta vencida na tela e melhor que PDP sem botao de compra.
// O parametro da recarga e _cmp=<fim>.<ms da recarga>, unico por recarga: um
// _cmp=<fim> igual para todo mundo podia ser guardado no cache de pagina da
// Shopify antes do fim (relogio adiantado) e servido velho depois dele.
// Os que ainda valem agendam a checagem para o fim, com UM timer so (checagem
// nova cancela o pendente). Timer sozinho nao basta (aparelho dormindo, aba
// congelada em segundo plano, bfcache): a checagem roda de novo quando a aba
// volta a ficar visivel, e a volta do bfcache conta como chegada. Elementos
// inseridos depois da carga (a gaveta do carrinho redesenha a barra por AJAX)
// tambem sao conferidos. No Theme Editor nada disso roda.
// Relogio regressivo (emenda E17): [data-campanha-relogio="<fim em segundos>"]
// mostra quanto falta para o fim. Com 24 h ou mais, "2d 14h" (sem segundos,
// para nao poluir); abaixo disso, "22:14:09". Sem JS o elemento fica com o
// texto que o Liquid escreveu (a data do fim). O elemento precisa ser
// aria-hidden: a gaveta do carrinho e aria-live e leria cada segundo.
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;

  // Essencial (sempre) e recarregar com a pagina aberta: nova recarga so
  // depois deste intervalo desde a ultima, para a mesma pagina e fim (limite
  // de uma por minuto, nunca laco).
  var JANELA_MS = 60000;
  var timer = null;

  function agoraS() { return Math.floor(Date.now() / 1000); }

  // true so quando de fato chama location.replace. janelaMs 0 = uma recarga
  // por sessao (qualquer marca bloqueia); > 0 = libera outra depois da janela.
  function recarregar(fim, janelaMs) {
    var chave = 'biobio-cmp:' + location.pathname + ':' + fim;
    try {
      var ultima = sessionStorage.getItem(chave);
      if (ultima !== null) {
        if (!janelaMs) return false;
        // marca ilegivel ou hora no futuro (relogio voltou): trata como recente
        if (!(Date.now() - parseInt(ultima, 10) > janelaMs)) return false;
      }
      sessionStorage.setItem(chave, String(Date.now()));
    } catch (e) { return false; }
    var u = new URL(location.href);
    u.searchParams.set('_cmp', fim + '.' + Date.now());
    location.replace(u.toString());
    return true;
  }

  function checar(naCarga) {
    var els = document.querySelectorAll('[data-campanha-fim]');
    var t = agoraS();
    var proximo = Infinity;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var fim = parseInt(el.getAttribute('data-campanha-fim'), 10);
      if (!fim) continue;
      if (t >= fim) {
        if (el.hasAttribute('data-campanha-essencial')) {
          if (recarregar(fim, JANELA_MS)) return;
          continue;
        }
        if (el.hasAttribute('data-campanha-recarregar') && recarregar(fim, naCarga ? 0 : JANELA_MS)) return;
        el.style.display = 'none';
      } else if (fim < proximo) {
        proximo = fim;
      }
    }
    if (timer !== null) { clearTimeout(timer); timer = null; }
    if (proximo !== Infinity) {
      var ms = (proximo - t) * 1000 + 500;
      if (ms < 2147483647) timer = setTimeout(function () { timer = null; checar(false); }, ms);
    }
    relogios();
  }

  // Um intervalo so, ligado apenas enquanto ha relogio valendo na pagina. So
  // escreve quando o texto muda (com dias, isso e uma vez por hora) e quando o
  // relogio esta visivel: com a gaveta do carrinho fechada nao ha escrita (nem
  // layout, nem mutacao para os gravadores de sessao); ao abrir, o proximo
  // tique acerta. A escrita troca um no de texto: o observador abaixo so olha
  // elementos, entao nao ha laco. Relogio vencido fica com o ultimo texto;
  // quem o esconde e o guarda, pelo [data-campanha-fim] do pai.
  var relogio = null;
  function dois(n) { return (n < 10 ? '0' : '') + n; }
  function faltam(seg) {
    if (seg >= 86400) return Math.floor(seg / 86400) + 'd ' + Math.floor((seg % 86400) / 3600) + 'h';
    return dois(Math.floor(seg / 3600)) + ':' + dois(Math.floor((seg % 3600) / 60)) + ':' + dois(seg % 60);
  }
  function relogios() {
    var els = document.querySelectorAll('[data-campanha-relogio]');
    var t = agoraS();
    var vivos = 0;
    for (var i = 0; i < els.length; i++) {
      var fim = parseInt(els[i].getAttribute('data-campanha-relogio'), 10);
      if (!fim || t >= fim) continue;
      vivos++;
      if (els[i].checkVisibility && !els[i].checkVisibility({ visibilityProperty: true, opacityProperty: true })) continue;
      var txt = faltam(fim - t);
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
    if (vivos && relogio === null) relogio = setInterval(relogios, 1000);
    if (!vivos && relogio !== null) { clearInterval(relogio); relogio = null; }
  }

  // Nodo inserido que e ou contem um [data-campanha-fim] ou um relogio.
  var MARCAS = '[data-campanha-fim], [data-campanha-relogio]';
  function temMarca(n) {
    if (!n || n.nodeType !== 1) return false;
    if (n.matches(MARCAS)) return true;
    return !!n.querySelector(MARCAS);
  }

  function iniciar() {
    checar(true);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') checar(false);
    });
    // Volta do bfcache: a pagina "chega" de novo, entao vale a regra da carga.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) checar(true);
    });

    // So childList: as escritas de style.display do proprio guarda sao
    // mudancas de atributo e nunca disparam o observador (sem laco). Varias
    // insercoes seguidas viram uma checagem so (microtarefa).
    if (window.MutationObserver && document.body) {
      var agendado = false;
      new MutationObserver(function (registros) {
        if (agendado) return;
        for (var i = 0; i < registros.length; i++) {
          var novos = registros[i].addedNodes;
          for (var j = 0; j < novos.length; j++) {
            if (temMarca(novos[j])) {
              agendado = true;
              Promise.resolve().then(function () { agendado = false; checar(false); });
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.BiobioCampanhas = { checar: checar };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
